import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {iif, Observable, of, throwError} from 'rxjs';
import {catchError, delay} from 'rxjs/operators';import {
  MiraAssetsResponse,
  MiraTelemetryValueResponse,
  MiraTelemetriesResponse, MiraTelemetry
} from '@common/mira/mira-model';
import {environment as env_const} from '@env/environment';
import {StoreService} from '@common/services/store.service';


// --- Datos Mock para /api/asset/all ---
const mockAssetsData: MiraAssetsResponse = {
  success: true,
  errors: "",
  assets: {
    "content": [
      {
        "createdAt": "2025-06-18 08:09:49.822/Z/",
        "updatedAt": "2025-06-18 08:09:49.822/Z/",
        "id": "ce370554-010b-4ae0-8a2e-10dcec2eb016",
        "name": "Asset Pepe",
        "description": null,
        "identifier": "AssetPepe",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": false,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-06-05 07:18:41.397/Z/",
        "updatedAt": "2025-06-05 07:18:41.397/Z/",
        "id": "d0dbb04f-8e18-42b5-af19-b2c0a7f70659",
        "name": "MAC PRO 2013",
        "description": null,
        "identifier": "MacPro2013",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": false,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 11:20:23.659/Z/",
        "updatedAt": "2025-03-20 11:42:30.688/Z/",
        "id": "911e992a-eed7-452c-8a49-dc6727272ed4",
        "name": "INSCAPE Session",
        "description": "This represents an XR application session in one device.",
        "identifier": "Device_Session_XR",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": true,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 11:18:59.800/Z/",
        "updatedAt": "2025-03-20 11:41:34.815/Z/",
        "id": "d36fc569-f63a-43ec-ae9f-1d28d026f62b",
        "name": "KAYROX Session",
        "description": "This represents an XR application session in one device.",
        "identifier": "Device_Session_XR",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": true,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 10:58:32.354/Z/",
        "updatedAt": "2025-03-20 10:58:32.354/Z/",
        "id": "bb21f3f0-58ff-4537-a9a6-bfad8e6b6b5d",
        "name": "TestPablo",
        "description": null,
        "identifier": "XRsteps0",
        "status": "ACTIVE",
        "category": "XRsteps",
        "hasNetwork": false,
        "hasTelemetry": false,
        "shared": false
      }
    ],
    "number": 0,
    "size": 10,
    "totalElements": 5,
    "totalPages": 1,
    "last": true
  }
};

// --- Datos Mock para /api/asset/{assetId}/telemetry/all ---
// Este mock devolverá telemetrías fijas, sin importar el assetId por simplicidad
const mockTelemetriesData: MiraTelemetriesResponse = {
  success: true,
  errors: "",
  telemetries: {
    "content": [
      {
        "createdAt": "2025-06-05 07:27:59.459/Z/",
        "updatedAt": "2025-07-28 15:37:36.742/Z/",
        "id": "107c3af0-6888-4d55-beca-a577ec95efb3",
        "name": "Temperature",
        "unit": "Celsius",
        "source": null,
        "identifier": "TemperatureMP2013",
        "type": "NUMERIC",
        "status": "ACTIVE",
        "dataSources": [
          {
            "id": "54d71a7e-da98-444d-a2dc-9ca77f74171d",
            "title": "MacPro2013_DT",
            "jsonKey": "PC_Status,Temperature_Celsius"
          }
        ],
        "relationType": null,
        "sharedDateRange": null,
        "shared": false
      } as MiraTelemetry,
      {
        "createdAt": "2025-06-05 07:26:50.828/Z/",
        "updatedAt": "2025-07-29 08:44:45.458/Z/",
        "id": "1f1212f2-9c3c-4be8-a8ee-d5f601d3bf0c",
        "name": "Power consumption",
        "unit": "Watts",
        "source": null,
        "identifier": "PowerConsumptionMP2013",
        "type": "NUMERIC",
        "status": "ACTIVE",
        "dataSources": [
          {
            "id": "54d71a7e-da98-444d-a2dc-9ca77f74171d",
            "title": "MacPro2013_DT",
            "jsonKey": "PC_Status,Power_Consumption_Watts"
          }
        ],
        "relationType": null,
        "sharedDateRange": null,
        "shared": false
      } as MiraTelemetry
    ],
    "number": 0,
    "size": 10,
    "totalElements": 2,
    "totalPages": 1,
    "last": true
  }
};

// --- Datos Mock para /api/asset/{assetId}/telemetry/{telemetryId}/value/latest ---
// Este mock devolverá un valor fijo para simplificar, sin importar assetId/telemetryId
const mockTelemetryValueData: MiraTelemetryValueResponse = {
  success: true,
  errors: "",
  telemetryValue: {
    "createdAt": null,
    "updatedAt": null,
    "id": "107c3af0-6888-4d55-beca-a577ec95efb3", // Puede que quieras que este ID coincida con el telemetryId solicitado
    "name": "Temperature",
    "identifier": "TemperatureMP2013",
    "unit": "Celsius",
    "value": 25.5
  }
};

@Injectable()
export class MiraService {
  // Simula un retardo mínimo de 500ms
  private readonly MOCK_DELAY_MS = 500;

  constructor(
    private http: HttpClient,
    private store: StoreService,
  ) {
  }

  public isMiraServiceAvailable(): boolean {
    return this.store.getCurrentUserMiraAccess() != null;
  }

  public getAssets$(page: number = 0, size: number = 10): Observable<MiraAssetsResponse> {
    // rest mira: /api/asset/all
    const restServiceUrl = `${env_const.apiUrl}get_mira_assets/`;

    let queryParams = new HttpParams();
    queryParams = queryParams.append('page', page.toString());
    queryParams = queryParams.append('size', size.toString());

    // Usamos 'iif' para decidir qué Observable emitir
    // const firstOrSecond = iif(   () => subscribeToFirst,   of('first'),   of('second') );
    return iif(
      () => this.isMiraServiceAvailable(),
      <Observable<MiraAssetsResponse>>this.http.get<MiraAssetsResponse>(restServiceUrl, { params: queryParams }).pipe(
        catchError(httpError => {
          console.error('Error al llamar al servicio de Assets del backend:', httpError);
          // Transforma el error HTTP al formato de MiraAssetsResponse
          return throwError(() => ( {
            success: false,
            errors: `Error at server getting assets: ${httpError.message || 'Unknown error.'}`,
            assets: null
          } ) as MiraAssetsResponse);
        })
      ),
      // Si isMiraServiceAvailable es false, emitimos directamente el error en el formato MiraAssetsResponse
      throwError(() => ({
        success: false,
        errors: 'Mira Service not available. Current user cannot get assets.',
        assets: null
      }) as MiraAssetsResponse)
    );
  }

  public getTelemetries$(assetId: string, page: number = 0, size: number = 10): Observable<MiraTelemetriesResponse> {
    // rest mira: /api/asset/{assetId}/telemetry/all
    const restServiceUrl = `${env_const.apiUrl}get_mira_telemetries/`;

    let queryParams = new HttpParams();
    queryParams = queryParams.append('asset_id', assetId);
    queryParams = queryParams.append('page', page.toString());
    queryParams = queryParams.append('size', size.toString());

    return iif(
      () => this.isMiraServiceAvailable(),
      this.http.get<MiraTelemetriesResponse>(restServiceUrl, { params: queryParams }).pipe(
        catchError(httpError => {
          console.error('Error at server getting telemetries: ', httpError);
          return throwError(() => ( {
            success: false,
            errors: `Error at server getting telemetries: ${httpError.message || 'Unknown error.'}`,
            telemetries: null
          } ) as MiraTelemetriesResponse);
        })
      ),
      throwError(() => ({
        success: false,
        errors: 'Mira Service not available. Current user cannot get telemetries.',
        telemetries: null
      }) as MiraTelemetriesResponse)
    );
  }

  public getTelemetryValue$(assetId: string, telemetryId: string): Observable<MiraTelemetryValueResponse> {
    // rest mira: /api/asset/{assetId}/telemetry/{telemetryId}/value/latest
    const restServiceUrl = `${env_const.apiUrl}get_mira_telemetry_value/`;

    let queryParams = new HttpParams();
    queryParams = queryParams.append('asset_id', assetId);
    queryParams = queryParams.append('telemetry_id', telemetryId);

    return iif(
      () => this.isMiraServiceAvailable(),
      this.http.get<MiraTelemetryValueResponse>(restServiceUrl, { params: queryParams }).pipe(
        catchError(httpError => {
          console.error('Error at server getting telemetry value:', httpError);
          return throwError(() => ( {
            success: false,
            errors: `Error at server getting telemetry value: ${httpError.message || 'Unknown error.'}`,
            telemetryValue: null
          } ) as MiraTelemetryValueResponse);
        })
      ),
      throwError(() => ({
        success: false,
        errors: 'Mira Service not available. Current user cannot get telemetry value.',
        telemetryValue: null
      }) as MiraTelemetryValueResponse)
    );
  }

  public getAssetsMock$(page: number = 0, size: number = 10): Observable<MiraAssetsResponse> {
    // Aquí podrías añadir lógica para paginación si 'page' y 'size' importan
    // Por simplicidad, siempre devolvemos todos los assets mock
    console.log(`Mock: Solicitando assets (página: ${page}, tamaño: ${size})`);
    return of(mockAssetsData).pipe(delay(this.MOCK_DELAY_MS));
  }

  public getTelemetriesMock$(assetId: string, page: number = 0, size: number = 10): Observable<MiraTelemetriesResponse> { // Cambiado a string para UUID
    // Aquí podrías añadir lógica para filtrar telemetrías por assetId real
    // Por simplicidad, siempre devolvemos todas las telemetrías mock
    console.log(`Mock: Solicitando telemetrías para assetId: ${assetId}`);
    return of(mockTelemetriesData).pipe(delay(this.MOCK_DELAY_MS));
  }

  public getTelemetryValueMock$(assetId: string, telemetryId: string): Observable<MiraTelemetryValueResponse> { // Cambiado a string para UUID
    // Aquí podrías añadir lógica para devolver un valor diferente basado en telemetryId
    // Por simplicidad, siempre devolvemos el mismo valor mock
    console.log(`Mock: Solicitando valor para assetId: ${assetId}, telemetryId: ${telemetryId}`);
    // Modificamos el valor de la telemetría mock para que parezca más dinámico
    const dynamicValue = (Math.random() * (30 - 20) + 20).toFixed(2); // Ejemplo: entre 20 y 30
    const responseWithDynamicValue: MiraTelemetryValueResponse = { ...mockTelemetryValueData, telemetryValue: { ...mockTelemetryValueData.telemetryValue, value: dynamicValue } };

    return of(responseWithDynamicValue).pipe(delay(this.MOCK_DELAY_MS));
  }
}


// rest mira: /api/asset/all
const assetsResponseExample =
{
  "data": {
    "content": [
      {
        "createdAt": "2025-06-18 08:09:49.822/Z/",
        "updatedAt": "2025-06-18 08:09:49.822/Z/",
        "id": "ce370554-010b-4ae0-8a2e-10dcec2eb016",
        "name": "Asset Pepe",
        "description": null,
        "identifier": "AssetPepe",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": false,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-06-05 07:18:41.397/Z/",
        "updatedAt": "2025-06-05 07:18:41.397/Z/",
        "id": "d0dbb04f-8e18-42b5-af19-b2c0a7f70659",
        "name": "MAC PRO 2013",
        "description": null,
        "identifier": "MacPro2013",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": false,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 11:20:23.659/Z/",
        "updatedAt": "2025-03-20 11:42:30.688/Z/",
        "id": "911e992a-eed7-452c-8a49-dc6727272ed4",
        "name": "INSCAPE Session",
        "description": "This represents an XR application session in one device.",
        "identifier": "Device_Session_XR",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": true,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 11:18:59.800/Z/",
        "updatedAt": "2025-03-20 11:41:34.815/Z/",
        "id": "d36fc569-f63a-43ec-ae9f-1d28d026f62b",
        "name": "KAYROX Session",
        "description": "This represents an XR application session in one device.",
        "identifier": "Device_Session_XR",
        "status": "ACTIVE",
        "category": null,
        "hasNetwork": true,
        "hasTelemetry": true,
        "shared": false
      },
      {
        "createdAt": "2025-03-20 10:58:32.354/Z/",
        "updatedAt": "2025-03-20 10:58:32.354/Z/",
        "id": "bb21f3f0-58ff-4537-a9a6-bfad8e6b6b5d",
        "name": "TestPablo",
        "description": null,
        "identifier": "XRsteps0",
        "status": "ACTIVE",
        "category": "XRsteps",
        "hasNetwork": false,
        "hasTelemetry": false,
        "shared": false
      }
    ],
    "number": 0,
    "size": 10,
    "totalElements": 5,
    "totalPages": 1,
    "last": true
  },
  "success": true
};


// rest mira: /api/asset/{assetId}/telemetry/all
const trlemetriesResponseExample =
{
  "data": {
    "content": [
      {
        "createdAt": "2025-06-05 07:27:59.459/Z/",
        "updatedAt": "2025-07-28 15:37:36.742/Z/",
        "id": "107c3af0-6888-4d55-beca-a577ec95efb3",
        "name": "Temperature",
        "unit": "Celsius",
        "source": null,
        "identifier": "TemperatureMP2013",
        "type": "NUMERIC",
        "status": "ACTIVE",
        "dataSources": [
          {
            "id": "54d71a7e-da98-444d-a2dc-9ca77f74171d",
            "title": "MacPro2013_DT",
            "jsonKey": "PC_Status,Temperature_Celsius"
          }
        ],
        "relationType": null,
        "sharedDateRange": null,
        "shared": false
      },
      {
        "createdAt": "2025-06-05 07:26:50.828/Z/",
        "updatedAt": "2025-07-29 08:44:45.458/Z/",
        "id": "1f1212f2-9c3c-4be8-a8ee-d5f601d3bf0c",
        "name": "Power consumption",
        "unit": "Watts",
        "source": null,
        "identifier": "PowerConsumptionMP2013",
        "type": "NUMERIC",
        "status": "ACTIVE",
        "dataSources": [
          {
            "id": "54d71a7e-da98-444d-a2dc-9ca77f74171d",
            "title": "MacPro2013_DT",
            "jsonKey": "PC_Status,Power_Consumption_Watts"
          }
        ],
        "relationType": null,
        "sharedDateRange": null,
        "shared": false
      }
    ],
    "number": 0,
    "size": 10,
    "totalElements": 2,
    "totalPages": 1,
    "last": true
  },
  "success": true
};


// rest mira: /api/asset/{assetId}/telemetry/{telemetryId}/value/latest
const telemetryValueResponseExample =
{
  "data": {
    "createdAt": null,
    "updatedAt": null,
    "id": "107c3af0-6888-4d55-beca-a577ec95efb3",
    "name": "Temperature",
    "identifier": "TemperatureMP2013",
    "unit": "Celsius",
    "value": null
  },
  "success": true
};
